import auth from './modules/auth'
import routers from './modules/routers'
import home from './modules/home'
import profiles from './modules/profiles'
import users from './modules/users'
import params from './modules/params'
import suppliers from './modules/suppliers'
import documents from './modules/documents'
import contracts from './modules/contracts'
import moviments from './modules/moviments'
import measures from './modules/measures'
import queries from './modules/queries'
import reports from './modules/reports'

export default {
  auth,
  routers,
  home,
  profiles,
  users,
  params,
  suppliers,
  documents,
  contracts,
  moviments,
  measures,
  queries,
  reports,
}
